import { EntityType } from '@frontend/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { DeceasedClient } from '@frontend/deceased/api';
import { DeceasedStatusBadge } from '@frontend/deceased/badge';
import { IDeceased } from '@frontend/deceased/types';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../redux/store';

const ID = 'deceased-overview';
export const DeceasedOverview = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    return (
        <ReactiveObjectList<IDeceased>
            id={ID}
            useStaticListId
            type={EntityType.DECEASED}
            dispatch={dispatch}
            fetch={(arg) => DeceasedClient.fetchDeceaseds(arg)}
            eventListener={EntityType.DECEASED}
            onSelectElement={(o) => navigate(`/accounts/${o.account_id}/deceased/${o.id}/detail`)}
            create={{
                label: CommonMessage.OBJECTS.DECEASED.DEFAULT,
                onCreate: () => navigate('./create'),
                requiredPermissions: [{ item: EntityType.DECEASED, source: EntityType.ACCOUNT, right: 'create', uid: currentAccount ?? '?' }]
            }}
            columns={{
                columns: ['name', 'state', 'spot_id', 'workflow_id', 'creation_timestamp'],
                headerOverwrite: new Map([
                    ['state', CommonMessage.OBJECTS.COMMON_FIELDS.STATUS],
                    ['spot_id', CommonMessage.OBJECTS.SPOT.DEFAULT],
                    ['workflow_id', CommonMessage.OBJECTS.WORKFLOW.DEFAULT]
                ]),
                customCells: new Map([
                    [
                        'state',
                        (obj) => (
                            <td
                                key={obj.row.original.id}
                                className={defaultCellClassName}>
                                <DeceasedStatusBadge status={obj.row.original.state} />
                            </td>
                        )
                    ]
                ])
            }}
            filter={{ default: true }}
            showCount
        />
    );
};
